import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import { deleteSlider, getSlider, updateSlider } from "../../../MyApi/slider";
import AddModalSlider from "../AddModalSlider";
import Can from "../../../utils/can";
import i18next from "i18next";

const SliderTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sliderModalMode, setSliderModalMode] = useState("create");
  const [sliderId, setSliderId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleShowSlider = (id) => {
    setSliderId(id);
    setSliderModalMode("show");
    setIsModalOpen(true);
  };

  const handleEditSlider = (id) => {
    setSliderId(id);
    setSliderModalMode("edit");
    setIsModalOpen(true);
  };

  const slidersColumns = [
      { label: "الصورة", render: (row) => (
    <img 
      src={row.image} 
      alt={row.title} 
      style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
    />
  )},
    { label: "العنوان", accessor: "title" },
    { label: "الوصف", accessor: "body" },
    { label: "نص الزر", accessor: "button_text" },
    { label: "الهدف", accessor: "target" },
    { label: "رقم الهدف", accessor: "target_id" },
    { label: "ترتيب العرض", accessor: "sort_order" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleShowSlider(row.id)}
          viewPermission={"view_slider"}
          edit={() => handleEditSlider(row.id)}
          editPermission={"update_slider"}
          deleteFn={deleteSlider}
          deletePermission={"delete_slider"}
          id={row.id}
          queryKey={"getSliders"}
          is_active={row.is_active}
          togglePermission={"update_slider"}
          toggleMutationKey={"toggle-update-slider"}
          toggleFn={(id, status) => updateSlider(id, {
            is_active: status,
            _method: "PUT",
            lang: i18next.language
          })}
        />
      ),
    },
  ];

  const {
    data: slidersData,
    isLoading: slidersLoading,
    refetch,
  } = useQuery(["getSliders", currentPage], () => getSlider(currentPage));

  const sliders = slidersData?.data?.sliders || [];
  const total = slidersData?.data?.pagination?.total || 0;
  const last_page = slidersData?.data?.pagination?.last_page || 0;

  return (
    <>
      <Can permission={"view_slider"}>
        <DataTable
          columns={slidersColumns}
          data={sliders}
          title="السلايدرات"
          actionLabel="إضافة سلايدر جديد"
          onAddClick={() => {
            setSliderModalMode("create");
            setSliderId(null);
            setIsModalOpen(true);
          }}
          isLoading={slidersLoading}
          createPermission={"create_slider"}
          totalItems={total}
          itemsPerPage={last_page}
          
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Can>
      <AddModalSlider
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSliderModalMode("create");
          setSliderId(null);
        }}
        refetch={refetch}
        mode={sliderModalMode}
        sliderId={sliderId}
      />
    </>
  );
};

export default SliderTab;